export type MediaLoaderKind = 'image' | 'video' | 'audio';

export function mediaLoaderKind(section: string | undefined): MediaLoaderKind {
  if (section === 'video' || section === 'video2') return 'video';
  if (section === 'audio' || section === 'voice') return 'audio';
  return 'image';
}

/** Small animated scene shown while a generation job is running. */
export function MediaLoader({ kind, size = 40 }: { kind: MediaLoaderKind; size?: number }) {
  return (
    <svg
      className={`media-loader media-loader-${kind}`}
      viewBox="0 0 48 48"
      width={size}
      height={size}
      role="presentation"
      aria-hidden="true"
    >
      {kind === 'image' && (
        <>
          <rect x="5" y="8" width="38" height="32" rx="5" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.5" />
          <path className="ml-stroke" d="M10 32 C16 20 22 38 28 26 S36 22 39 16" fill="none" stroke="var(--accent)" strokeWidth="3.5" strokeLinecap="round" />
          <g className="ml-brush">
            <path d="M0 0 l5 -5 l3 3 l-5 5 z" fill="currentColor" />
            <path d="M-1 1 c-2 0 -3 1 -3 3 c2 0 3 -1 3 -3 z" fill="var(--accent)" />
          </g>
        </>
      )}
      {kind === 'video' && (
        <>
          <rect x="4" y="10" width="40" height="28" rx="4" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.5" />
          <g className="ml-frames">
            <rect x="9" y="16" width="10" height="16" rx="2" fill="var(--accent)" />
            <rect x="22" y="16" width="10" height="16" rx="2" fill="var(--accent)" opacity="0.7" />
            <rect x="35" y="16" width="10" height="16" rx="2" fill="var(--accent)" opacity="0.5" />
            <rect x="-4" y="16" width="10" height="16" rx="2" fill="var(--accent)" opacity="0.5" />
          </g>
        </>
      )}
      {kind === 'audio' && (
        <>
          <g className="ml-note ml-note-a"><ellipse cx="12" cy="34" rx="4" ry="3" fill="var(--accent)" /><path d="M16 34 V14" stroke="var(--accent)" strokeWidth="2" /></g>
          <g className="ml-note ml-note-b"><ellipse cx="25" cy="38" rx="4" ry="3" fill="var(--accent)" opacity="0.8" /><path d="M29 38 V18" stroke="var(--accent)" strokeWidth="2" opacity="0.8" /></g>
          <g className="ml-note ml-note-c"><ellipse cx="38" cy="32" rx="4" ry="3" fill="var(--accent)" opacity="0.6" /><path d="M42 32 V12" stroke="var(--accent)" strokeWidth="2" opacity="0.6" /></g>
        </>
      )}
    </svg>
  );
}
